<template>
  <div>
    <div
      v-if="innerStep === STEPS.OFFER"
      class="p-5 flex flex-col items-center text-center"
    >
      <BaseText
        type="label"
        size="lg"
        class="text-text-loud pt-5"
      >
        <span class="text-secondary-green-200">Save ${{ upsellPlan.annualSavings }}</span> by switching to annual billing.
      </BaseText>
      <BaseText
        size="sm"
        class="text-text-normal"
      >
        93% of Foreplay users stay for more than 12 months. Upgrade to an annual subscription now and save $840/year.
      </BaseText>
    </div>
    <div
      v-else
      class="p-5 flex flex-col items-center text-center"
    >
      <BaseText
        type="label"
        size="lg"
        class="text-text-loud pt-5"
      >
        Ready to save and unlock more?
      </BaseText>
      <BaseText
        size="sm"
        class="text-text-normal"
      >
        You're about to switch to the Annual plan for {{ formattedPrice }}/year.
      </BaseText>
    </div>
    <div>
      <div
        class="flex flex-col justify-between px-5"
        :class="{ 'pt-5': innerStep === STEPS.OFFER }"
      >
        <div
          v-if="innerStep === STEPS.OFFER"
          class="w-full border border-border-normal rounded-xl p-3 relative overflow-hidden"
        >
          <!-- Product icon  -->
          <img
            src="../../../../assets/icons/spyder-token.png"
            class="absolute top-0 bottom-0 -right-16 my-auto"
            style="height: 168px; width: 168px;"
          >
          <div class="flex items-center gap-1 text-text-normal">
            <GiftIcon />
            <BaseText
              type="label"
              size="sm"
            >
              Bonus
            </BaseText>
          </div>
          <BaseText
            type="label"
            size="sm"
            class="text-text-muted mt-3"
          >
            Unlimited Spyder credits
          </BaseText>
          <BaseText
            size="sm"
            class="text-text-normal max-w-xs mt-1"
          >
            Annual subscriptions are the only way to get Unlimited Spyder credits.
          </BaseText>
          <div class="flex items-center gap-1 mt-3">
            <!--  -->
            <MoneyCircleIcon class="text-secondary-green-200" />
            <BaseText
              class="text-secondary-green-200"
              type="label"
              size="sm"
            >
              $3,000 value for free.
            </BaseText>
          </div>
        </div>

        <!-- Cta -->
        <div
          class="flex flex-col w-full items-center gap-3 py-5"
          :class="{ 'pt-10': innerStep === STEPS.OFFER }"
        >
          <div class="space-y-2.5 w-full">
            <button
              class="black-btn-primary rounded-md py-2 px-2.5 text-white w-full"
              :disabled="loading"
              @click="handleStep"
            >
              <div
                v-if="innerStep === STEPS.OFFER"
                class="flex items-center justify-center w-full"
              >
                <BaseLoadingSpinnerCircle
                  v-if="loading"
                />
                <BaseText
                  v-else
                  type="label"
                  size="sm"
                >
                  Yes, Upgrade to Annual ({{ formattedPrice }})
                </BaseText>
              </div>
              <div v-else>
                <BaseLoadingSpinnerCircle
                  v-if="loading"
                />
                <BaseText
                  v-else
                  type="label"
                  size="sm"
                >
                  Confirm Upgrade
                </BaseText>
              </div>
            </button>
            <BaseText
              size="xs"
              class="text-text-normal text-center"
            >
              Your monthly subscription will be refunded immediately
            </BaseText>
          </div>
          <button
            class="hover:bg-background-normal rounded-md w-max py-2 px-2.5"
            @click="$emit('skip')"
          >
            <BaseText
              type="label"
              size="sm"
              class="text-text-muted"
            >
              {{ innerStep === STEPS.OFFER ? 'No thanks, bill me monthly' : 'Cancel' }}
            </BaseText>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stripeProducts from '../../../../utils/stripe/products'
// Icons
import GiftIcon from '../../../globals/Icons/GiftIcon.vue'
import MoneyCircleIcon from '../../../globals/Icons/MoneyCircleIcon.vue'
export default {
  name: 'SpyderAnnualUpsell',
  components: {
    MoneyCircleIcon,
    GiftIcon
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const STEPS = {
      OFFER: 0,
      CONFIRM: 1
    }
    return {
      STEPS,
      innerStep: STEPS.OFFER
    }
  },
  computed: {
    formattedPrice () {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(this.upsellPlan?.marketAnnual || 0)
    },
    upsellPlan () {
      // If we are on basic - find next tier annual
      const keyToFind = this.product.key === 'basic_plan' ? 'workflow_plan' : this.product.key
      const upsellPlanIndex = stripeProducts.findIndex((plan) => plan.key === keyToFind)
      return stripeProducts?.[upsellPlanIndex]
    }
  },
  methods: {
    handleStep () {
      if (this.innerStep === this.STEPS.OFFER) {
        this.innerStep = this.STEPS.CONFIRM
      } else if (this.innerStep === this.STEPS.CONFIRM) {
        this.updateSubscription()
      }
    },
    updateSubscription () {
      if (this.loading) return
      const lensCart = this.upsellPlan?.addOns?.lens?.annual
      const spyderCart = this.upsellPlan?.addOns?.spyder?.annual
      const updatePayload = {
        key: this.upsellPlan.key,
        priceId: this.upsellPlan.priceId.annual,
        addOn: {
          ...(lensCart && { lens: lensCart }),
          ...(spyderCart && { spyder: spyderCart })
        }
      }
      this.$emit('updateSubscription', updatePayload)
    }
  }
}
</script>
